import { render, staticRenderFns } from "./DeviceSerialNumber.vue?vue&type=template&id=31e17141&scoped=true"
import script from "./DeviceSerialNumber.vue?vue&type=script&lang=js"
export * from "./DeviceSerialNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e17141",
  null
  
)

export default component.exports